import {z} from 'zod';
import {PersonalData} from './personal-data';
import {Date} from './date';

export const BankDetails = z.object({
  iban: z.string().nullable(),
  bic: z.string().nullable(),
  bankName: z.string().nullable(),
  accountOwner: PersonalData.nullable(),
  validFrom: Date.nullable(),
});

export type BankDetails = z.infer<typeof BankDetails>;
